import { render, staticRenderFns } from "./DatatableBillets.vue?vue&type=template&id=5a6a6687"
import script from "./DatatableBillets.vue?vue&type=script&lang=js"
export * from "./DatatableBillets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports